module.exports = __webpack_public_path__ + "static/media/wordpress.c0f3de97.png";